import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { bugsnagClient } from "../../bugsnag/bugsnagClient";
import { actionCoopPointsInfoRequest } from "../../cooperative/actionCoop";
import { actionPlayerInfo } from "./actionPlayerInfo";
var setPlayerInfoInBugsnag = function (res) {
    bugsnagClient.bugsnag.user = { id: "" + res.playerId, name: res.name };
    bugsnagClient.bugsnag.metaData = { playerLevel: res.level };
};
export var epicPlayerInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.PlayerInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), switchMap(function (res) {
        setPlayerInfoInBugsnag(res);
        if (res.playerId && res.coopId) {
            return from([
                actionPlayerInfo(res),
                actionCoopPointsInfoRequest(res.playerId, res.coopId),
            ]);
        }
        return of(actionPlayerInfo(res));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player/epicPlayerInfo.ts
// module id = 1929
// module chunks = 3